/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DocumentListResponse = {
    type: 'array',
    contains: {
        type: 'DocumentResponse',
    },
};